// extracted by mini-css-extract-plugin
module.exports = {"resources":"Resources_resources__1EUQB","intro":"Resources_intro__3E9P3","content":"Resources_content__1C6v0","card":"Resources_card__3e2h0"};